import React, { useEffect, useState } from "react";

export default function FacebookCallback() {
  const [done, setDone] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (code) {
      localStorage.setItem("fb_oauth_code", code);
      setDone(true);
      // Try closing - may be blocked by browser
      window.close();
    }
  }, []);

  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "center",
      height: "100vh", fontFamily: "'Inter', sans-serif", color: "#374151",
    }}>
      <div style={{ textAlign: "center" }}>
        {done ? (
          <>
            <p style={{ fontSize: 16, fontWeight: 500 }}>Facebook connected! You can close this window.</p>
          </>
        ) : (
          <>
            <p style={{ fontSize: 16, fontWeight: 500 }}>Connecting your Facebook Page…</p>
            <p style={{ fontSize: 13, color: "#9ca3af" }}>This window will close automatically.</p>
          </>
        )}
      </div>
    </div>
  );
}
